import { buildApiUrl } from './apiUrl';

export async function downloadPdfById(pdfId, pdfName) {
	const response = await fetch(buildApiUrl(`pdfs/${pdfId}/file`), {
		credentials: 'include',
	});
	if (!response.ok) {
		throw new Error('Kunne ikke laste ned PDF');
	}
	const blob = await response.blob();
	const url = window.URL.createObjectURL(blob);
	const link = document.createElement('a');
	link.href = url;
	link.setAttribute('download', pdfName || 'bestilling.pdf');
	document.body.appendChild(link);
	link.click();
	link.remove();
	window.URL.revokeObjectURL(url);
}
